import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { TargetingReadOnlyList } from '@openx/components-package/components/PackageDetails/sections/TargetingReadOnlyList.tsx';
import { packageToFormState } from '@openx/components-package/components/PackageForm/utils/formStateConverter.ts';
import { useFilteredTargetingItems } from '@openx/components-package/utils/hooks/useFilteredTargetingItems.ts';
import type { PackageWithTargeting } from '@openx/types/package.ts';
import { type JSX, useMemo } from 'react';
import type { DealDetailsProps } from '../../../types/index.ts';
import { StyledFormSectionContainer } from './styledComponents/FormSectionContainer.styled.tsx';

export const TargetingCriteriaSection = ({ deal }: DealDetailsProps): JSX.Element => {
  const packageState = useMemo(() => packageToFormState((deal as Partial<PackageWithTargeting>) || {}), [deal]);
  const matchesWidth = useMediaQuery('(max-width: 760px)');
  const targeting = useFilteredTargetingItems(packageState);

  return (
    <StyledFormSectionContainer>
      <FormSection divider title="Targeting Criteria">
        <Grid size={matchesWidth ? 10 : 8}>
          <TargetingReadOnlyList targeting={targeting} packageState={packageState} />
        </Grid>
      </FormSection>
    </StyledFormSectionContainer>
  );
};
